import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'

export default function MeetTheTeam() {
    const team = [
        {
            image: '/assets/team/justin.webp',
            name: 'Justin Silverio',
            designation: 'Founder & CEO',
        },
        {
            image: '/assets/team/kayla_bragg.webp',
            name: 'Kayla Bragg',
            designation: 'COO',
        },
        {
            image: '/assets/team/charlie_arseniou.webp',
            name: 'Charlie Arseniou',
            designation: 'Production Lead',
        },
        {
            image: '/assets/team/jake_soper.webp',
            name: 'Jake Soper',
            designation: 'CSR',
        },
        {
            image: '/assets/team/jenn_brown.webp',
            name: 'Jenn Brown',
            designation: 'CSR',
        },
        {
            image: '/assets/team/adrian.webp',
            name: 'Adrian',
            designation: 'CSR',
        },
        {
            image: '/assets/team/lex.webp',
            name: 'Lex',
            designation: 'Prepress Lead',
        },
        {
            image: '/assets/team/mary.webp',
            name: 'Mary',
            designation: 'HR/Admin',
        },
        {
            image: '/assets/team/austin.webp',
            name: 'Austin',
            designation: 'Production Associate',
        },
        {
            image: '/assets/team/shawn.webp',
            name: 'Shawn',
            designation: 'Production Associate',
        },
        {
            image: '/assets/team/rhodney.webp',
            name: 'Rhodney',
            designation: 'Prepress Associate',
        },
        {
            image: '/assets/team/julius.webp',
            name: 'Julius',
            designation: 'Prepress Associate',
        },
        {
            image: '/assets/team/victoria_cid.webp',
            name: 'Victoria Cid',
            designation: 'Prepress Associate',
        },
    ]

    const settings = {
        arrows: true,
        dots: false,
        className: 'align-items-center',
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
    }

    return (
        <div className="md:rounded-[120px] rounded-[70px] bg-gradient-to-b from-[#fdedce] via-transparent to-[#fdedce] ">
            <div className="container mx-auto py-28 px-8 text-center space-y-8">
                <h3 className="font-bold text-3xl md:text-[45px] md:leading-[52px] md:mb-[60px]">
                    Meet the Team
                </h3>
                <div className="md:grid hidden gap-6 md:grid-cols-2 lg:grid-cols-4 lg:max-w-none">
                    {team.map((member, i) => (
                        <div key={i} className="flex flex-col space-y-3">
                            <div>
                                <img
                                    src={member.image}
                                    alt={member.name}
                                    title={member.name}
                                    className="inline-block w-[90%] olm-gradient rounded-full"
                                />
                            </div>
                            <div className="text-center">
                                <h4 className="font-bold text-[25px] leading-[30px]">
                                    {member.name}
                                </h4>
                                <p className="text-base leading-7 font-medium">
                                    {member.designation}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="mx-[2rem] block md:hidden">
                    <Slider {...settings}>
                        {team.map((member, i) => (
                            <div key={i} className="px-3 py-4">
                                <div className="flex flex-col space-y-3">
                                    <div>
                                        <img
                                            src={member.image}
                                            alt={member.name}
                                            title={member.name}
                                            className="inline-block w-[90%] mx-auto"
                                        />
                                    </div>
                                    <div className="text-center">
                                        <h4 className="font-bold text-[25px] leading-[30px]">
                                            {member.name}
                                        </h4>
                                        <p className="text-base leading-7 font-medium">
                                            {member.designation}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </div>
    )
}
